import styled from "styled-components";

import SntTooltip from "@cleanup/components/Tooltip/SntTooltip";
import { SntColor } from "@cleanup/constants/SntColor";
import { translate } from "@/hooks/useLanguage";
import { LanguageKey } from "@/types/generated/LanguageKey";

const Circle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${SntColor.Sensolus_Grey_Light};
  color: #ffffff;
  font-size: 8px;
  font-weight: 700;
  line-height: 1;
  vertical-align: middle;
  user-select: none;
  margin-left: 4px;
`;

interface SensolusOnlyBadgeProps {
  /**
   * True when the underlying element is visible to SYSTEM organisations only.
   * Usually sourced from a backend `systemOnly` flag (e.g. ColumnDescriptorDto).
   */
  systemOnly?: boolean;
  className?: string;
  tooltipText?: string;
}

/**
 * Renders a small navy "S" badge after a label to mark UI elements that are
 * visible to Sensolus internal users only. Renders whenever `systemOnly` is
 * true — no viewer-org check needed: the underlying element is already gated
 * by permission/visibility upstream, so if the badge reaches a non-Sensolus
 * viewer that's a data-leak signal worth flagging.
 */
const SensolusOnlyBadge = ({
  systemOnly,
  className,
  tooltipText,
}: SensolusOnlyBadgeProps) => {
  if (!systemOnly) {
    return null;
  }

  return (
    <SntTooltip
      className={className}
      text={tooltipText ?? translate(LanguageKey.system_only_indicator_tooltip_key)}
      icon={<Circle>S</Circle>}
    />
  );
};

export default SensolusOnlyBadge;
